import styled from '@emotion/styled';

export const StyledUserForm = styled.form({
    height: '100%',
    width: '100%',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
});
